import en from "@/assets/lang/en.json";
import no from "@/assets/lang/no.json";
import sv from "@/assets/lang/sv.json";
import zhCN from "@/assets/lang/zh-CN.json";
import zhHK from "@/assets/lang/zh-HK.json";

export const fallbackLocale = "en";

export const messages = {
  en,
  no,
  nb: no,
  sv,
  "zh-CN": zhCN,
  "zh-HK": zhHK,
};

export function normalizeLocale(locale) {
  const input = (locale || "").trim();
  const normalized = input.replace("_", "-");
  const lower = normalized.toLowerCase();
  const language = lower.slice(0, 2);

  if (lower === "zh-hk") {
    return "zh-HK";
  }

  if (lower === "zh-cn" || language === "zh") {
    return "zh-CN";
  }

  if (language === "nb" || language === "no") {
    return "no";
  }

  if (language === "sv") {
    return "sv";
  }

  if (language === "en") {
    return "en";
  }

  return fallbackLocale;
}

export function getStoredLocale() {
  return normalizeLocale(localStorage.getItem("lang"));
}

export function setStoredLocale(locale) {
  const normalizedLocale = normalizeLocale(locale);
  localStorage.setItem("lang", normalizedLocale);
  return normalizedLocale;
}

export function getPreferredLocale() {
  const storedLocale = localStorage.getItem("lang");

  if (storedLocale) {
    return normalizeLocale(storedLocale);
  }

  return normalizeLocale(navigator.language);
}

export function createLegacyI18nOptions() {
  return {
    locale: getPreferredLocale(),
    messages,
  };
}

export function createModernI18nOptions() {
  return {
    legacy: true,
    globalInjection: true,
    locale: getPreferredLocale(),
    fallbackLocale,
    messages,
  };
}
